import { useEffect } from 'react';

function useDocumentTitle(title) {
    useEffect(() => {
        document.title = title + ' - Parkrun Forever Draw | Thank You Prize Draw';
    }, [title]);
}

export default useDocumentTitle;